import React, { useState, useRef, useEffect } from "react";
import { IonApp, IonContent, IonHeader, IonIcon, IonItem, IonLabel, IonList, IonMenu, IonMenuToggle, IonPage, IonRadio, IonRadioGroup, IonTitle, IonToolbar } from '@ionic/react';
import topics from "../menus/Nursery/Nursery";

const Nursery: React.FC = () => {

    const handleSubmit = (url: string) => {
        window.location.href = url;
    }

    useEffect(() => {
        document.title = "Mamas Guidance - Nursery"; // Set page title
    }, []);

    return (
        <div className={`my-topic-container`}>
            {/* <div className="olympiad-grid">
                {topics.map((slide, index) => (
                    <div key={index} className="olympiad-card imo">
                        <h3>{slide.title}</h3>
                        <IonItem routerLink={slide.url}
                            routerDirection="none"
                            lines="none"
                            detail={false}>
                            <IonLabel>Start Now</IonLabel>
                        </IonItem>
                    </div>
                ))}
            </div> */}
            {topics.map((slide, index) => (
                <IonItem key={index} routerLink={slide.url}
                    routerDirection="none"
                    lines="none"
                    detail={true}>
                    <IonLabel>{slide.title}</IonLabel>
                </IonItem>
            ))}
        </div>
    );
};
export default Nursery;